import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ApprovalScopeService } from 'services/corporate/approval-scope.service';

const AUTO_DISMISS_MS = 15000;
const TICK_MS = 100;

@Component({
  selector: 'app-approval-scope-opening-instructions-banner',
  templateUrl: './approval-scope-opening-instructions-banner.component.html',
  styleUrls: ['./approval-scope-opening-instructions-banner.component.scss'],
})
export class ApprovalScopeOpeningInstructionsBannerComponent implements OnInit, OnDestroy {
  @Input() instructions = '';
  @Input() approvalScopeId = '';
  @Input() canHidePreference = false;
  @Input() dismissible = true;
  @Input() title = 'Instruções';

  @Output() dismissed = new EventEmitter<void>();

  public progressValue = 0;
  public isSavingPreference = false;

  private _timerId: ReturnType<typeof setInterval> | null = null;
  private _elapsedMs = 0;

  constructor(private _approvalScopeService: ApprovalScopeService) {}

  ngOnInit(): void {
    if (this.dismissible) {
      this._startAutoDismissTimer();
    }
  }

  ngOnDestroy(): void {
    this._clearTimer();
  }

  onClose(): void {
    this.dismiss();
  }

  async onDontShowAgain(): Promise<void> {
    if (this.isSavingPreference || !this.canHidePreference || !this.approvalScopeId) {
      return;
    }

    this.isSavingPreference = true;
    try {
      await this._approvalScopeService.hideOpeningInstructions(this.approvalScopeId).toPromise();
    } catch {
      // fail-open: fecha o banner mesmo se a preferência não puder ser salva
    } finally {
      this.isSavingPreference = false;
    }

    this.dismiss();
  }

  private dismiss(): void {
    this._clearTimer();
    this.dismissed.emit();
  }

  private _startAutoDismissTimer(): void {
    this._timerId = setInterval(() => {
      this._elapsedMs += TICK_MS;
      this.progressValue = Math.min(100, (this._elapsedMs / AUTO_DISMISS_MS) * 100);

      if (this._elapsedMs >= AUTO_DISMISS_MS) {
        this.dismiss();
      }
    }, TICK_MS);
  }

  private _clearTimer(): void {
    if (this._timerId != null) {
      clearInterval(this._timerId);
      this._timerId = null;
    }
  }
}
